import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HrTranslateSpanComponent } from './hr-translate-span.component';
import { TableModule } from 'primeng/table';

@NgModule({
    declarations: [HrTranslateSpanComponent],
    imports: [CommonModule, TranslateModule, TableModule],
    exports: [HrTranslateSpanComponent],
})
export class HrTranslateSpanModule {}
